import React from "react";
import { CheckCircle2, Clock, AlertTriangle, XCircle } from "lucide-react";

const map = {
    conducted: { cls: "bg-green-100 text-green-800 border-green-200", icon: CheckCircle2, label: "Conducted" },
    upcoming: { cls: "bg-blue-100 text-blue-800 border-blue-200", icon: Clock, label: "Upcoming" },
    overdue: { cls: "bg-yellow-100 text-yellow-800 border-yellow-200", icon: AlertTriangle, label: "Overdue" },
    missed: { cls: "bg-red-100 text-red-800 border-red-200", icon: XCircle, label: "Missed" },
};

const StatusBadge = ({ status }) => {
    const s = map[status] || map.upcoming;
    const Icon = s.icon;
    return (
        <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium border ${s.cls}`}>
            <Icon className="h-3 w-3" />
            {s.label}
        </span>
    );
};

export default StatusBadge;
